module.exports = __webpack_public_path__ + "img/national-emblem.73b3a4ac.png";